const $ = jQuery.noConflict();
var FontFaceObserver = require('fontfaceobserver');

class GoalCards {
    constructor() {
        this.cardBottom = $('.block-goal-cards__card-content-bottom');
        this.cardButton = $('.block-goal-cards__card');
        this.bottomContent = $('.strategies-lightbox__bottom-content');
        this.lightboxGoalButton = $('.strategies-lightbox__goals-button');
        this.strategiesLightbox = $('.strategies-lightbox');
        this.closeButton = $('.strategies-lightbox__back, .strategies-lightbox__close');
        this.contentCol = $('.strategies-lightbox__content-col');
        this.imageCol = $('.strategies-lightbox__image-col');
        this.goalsTop = $('.strategies-lightbox__goals-top');
        this.pbody = $('body');
    }
    init( fontFace = 'HCo Gotham SSm') {
        var instance = this;
        var font = new FontFaceObserver(fontFace);
        
        font.load().then(function () {
            instance.transformCards();

            setTimeout(function() {
                $('.block-goal-cards__card').addClass('loaded');
            }, 1);
        });

        const {
            cardBottom,
            cardButton,
            bottomContent,
            lightboxGoalButton,
            strategiesLightbox,
            closeButton,
            contentCol,
            imageCol,
            goalsTop,
            pbody
        } = this;

        lightboxGoalButton.on('click', switchLightbox);
        cardButton.on('click', openLightbox);
        closeButton.on('click', closeLightbox);
        $(document).on('keyup', closeLightbox);

        function switchLightbox(e) {
            if (!$(this).hasClass('card-active')) {
                e.preventDefault();
                lightboxGoalButton.removeClass('card-active');
                var cardID = $(this).attr('data-id');
                $('[data-id]').removeClass('animate');
                goalsTop.removeClass('active');
                contentCol.slideUp();
                imageCol.slideUp();
                $('.strategies-lightbox__goals-button[data-id="' + cardID + '"]').addClass('card-active');
                $('.block-goal-cards__card.active[data-target!="' + cardID + '"]').addClass('fadeOut');
                $('.block-goal-cards__card[data-target="' + cardID + '"]').addClass('switched');
                
                bottomContent.animate({
                    scrollTop: 0,
                }, 500, 'swing');

                setTimeout(function() {
                    $('.block-goal-cards__card[data-target!="' + cardID + '"], .strategies-lightbox__hero-content[data-id!="' + cardID + '"]').removeClass('switched switched2').find('.block-goal-cards__card-image-wrapper');
                    $('.block-goal-cards__card[data-target="' + cardID + '"]').addClass('switched2').click();
                }, 300);

                setTimeout(function() {
                    $('.block-goal-cards__card[data-target!="' + cardID + '"], .strategies-lightbox__hero-content[data-id!="' + cardID + '"]').removeClass('active card-active animate fadeOut').css('transform', 'translateX(0)');
                }, 650);
            } else {
                e.preventDefault();
                $(this).parent().toggleClass('active');
            }
        }

        function openLightbox(e) {
            e.preventDefault;
            pbody.addClass('lock-scroll').addClass('goal-card-open');
            var thisCard = e.currentTarget;
            var leftPos  = thisCard.getBoundingClientRect().left;
            var lightboxTarget = $(thisCard).attr('data-target');

            strategiesLightbox.addClass('active');
            $(lightboxTarget).addClass('active');
            $('[data-id="' + lightboxTarget + '"]').addClass('card-active');

            $('html, body').animate({
                scrollTop: $(thisCard).offset().top,
            }, 500, 'swing');

            $(thisCard).addClass('active animate').removeClass('fadeOut').find('.block-goal-cards__card-image-wrapper').css({'transform': 'translateX(-' + leftPos + 'px)'});
            
            setTimeout(function() {
                $('[data-id="' + lightboxTarget + '"]').addClass('animate');
                closeButton.addClass('animate');
                bottomContent.addClass('animate');
                $('.strategies-lightbox__content-col[data-id="' + lightboxTarget + '"], .strategies-lightbox__image-col[data-id="' + lightboxTarget + '"]').slideDown();
            }, 1);
            
            setTimeout(function() {
                bottomContent.addClass('opened');
            }, 700);
        }

        function closeLightbox(e) {
            if (e.target == this || e.key == "Escape") {
                e.preventDefault();
                $('.animate').removeClass('animate');
                $('.switched').removeClass('switched');
                $('.switched2').removeClass('switched2');
                $('.fadeOut').removeClass('fadeOut');
                $('.opened').removeClass('opened');
            
                setTimeout(function() {
                    $('.active').removeClass('active');
                    $('.card-active').removeClass('card-active');
                    pbody.removeClass('lock-scroll').removeClass('goal-card-open');;
                    contentCol.hide();
                    imageCol.hide();
                }, 650);
            }
        }
    }
    transformCards() {
        this.cardBottom.each(function() {
            var height = $(this).outerHeight() - 23;
            if ( $('body').hasClass('page-template-tpl-donor-page') ) {
                height = $(this).find('.block-goal-cards__explore-button').outerHeight() - 23;
            }

            if (height > 0) {
                $(this).prev('.block-goal-cards__card-content-top').first().css('transform', 'translateY(' + height + 'px)');
                $(this).css('transform', 'translateY(' + height + 'px)');
            }
        });
    }
}

export default new GoalCards();